<template>
  <div class="portal-page-fill gate-details">
    <div class="gate-manager" v-if="refinedGates">
      <div class="top-header toolbar-card">
        <div class="search">
          <div class="icon">
            <span class="mdi mdi-magnify"></span>
          </div>
          <input
            class="search-bar"
            :placeholder="$t('search.gateplaceholder')"
            v-model="search"
          />
        </div>
        <div class="filters-container">
          <GateTabs :value="filter" @update="updatefilter" />
        </div>
        <div class="create-gate">
          <span
            v-if="canCreateGate"
            @click="createNewGate"
            class="mdi mdi-plus-circle-outline add"
          ></span>
        </div>
      </div>
    </div>
    <div class="gate-reports portal-reports">
      <h6 class="report-title">
        Gate Add/Delete Reports:
        <date-picker
          v-model="selectedDate"
          range
          :format="dateFormat"
          :placeholder="[[currentDate]] + ' ~ ' + [[currentDate]]"
        ></date-picker>
        <input
          class="radio-btn"
          type="radio"
          id="PDF"
          value="pdf"
          v-model="fileFormat"
        />
        <label for="PDF">PDF</label>
        <input
          class="radio-btn"
          type="radio"
          id="CSV"
          value="csv"
          v-model="fileFormat"
        />
        <label for="CSV">CSV</label>
        <input
          class="radio-btn"
          type="radio"
          id="EXCEL"
          value="xlsx"
          v-model="fileFormat"
        />
        <label for="EXCEL">EXCEL</label>
        <button
          class="btn btn-primary float-right report-btn"
          @click="downloadReports"
        >
          Download Reports
        </button>
      </h6>
    </div>
    <div ref="gateTable" class="gate-table portal-table-wrap table-card">
      <div class="portal-table-scroll">
        <table class="table">
          <thead>
          <tr class="table-header">
            <th
              class="user-table-headers"
              :class="[{ sorting: sort == 'name' }, direction]"
              @click="updateSort('name')"
            >
              {{ $t('gate.name') }}
            </th>
            <th
              class="user-table-headers"
              :class="[{ sorting: sort == 'status' }, direction]"
              @click="updateSort('status')"
            >
              {{ $t('gate.status') }}
            </th>
            <th
              class="user-table-headers"
              v-if="canEditGate || canDeleteGate"
            >
              {{ $t('gate.action') }}
            </th>
          </tr>
        </thead>
        <PortalTableBody
          :loading="loading"
          variant="name-status"
          :show-actions="canEditGate || canDeleteGate"
        >
          <tr v-for="(item, idx) in refinedGates" :key="item.id || idx">
            <td>{{ item.display_name }}</td>
            <td v-if="item.is_active == 0">Disabled</td>
            <td v-else>Enabled</td>
            <td v-if="canEditGate || canDeleteGate">
              <div class="row d-flex justify-content-center">
                <div v-if="canEditGate" class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editGateDetails(idx)"
                  ></span>
                </div>
                <div v-if="canDeleteGate" class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(idx)"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="!loading && refinedGates.length === 0">
            <td :colspan="canEditGate || canDeleteGate ? 3 : 2" class="no-data-cell">
              No gates found
            </td>
          </tr>
        </PortalTableBody>
        </table>
      </div>
    </div>
    <div class="footer portal-footer">
      <div class="results">
        <span class="mdi mdi-format-list-bulleted results-icon" aria-hidden="true"></span>
        {{ $t("displayresults.display") }} <strong>{{ resultsCopy }}</strong> {{ $t("displayresults.results")}}
      </div>
    </div>
    <!-- Pop Up Modal -->
    <div v-if="myModel">
      <transition name="model">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click="myModel = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="confirmation pb-4" style="text-align: center">
                    <h4>{{ $t('deletepop.message') }}</h4>
                  </div>
                  <div align="center">
                    <input
                      type="button"
                      class="btn btn-primary"
                      style="margin-right: 10px; width: 100px"
                      :value="$t('deletepop.okbtn')"
                      @click="deleteGate(modalData)"
                    />
                    <input
                      type="button"
                      class="btn btn-danger"
                      style="margin-left: 10px; width: 100px"
                      :value="$t('deletepop.cancelbtn')"
                      @click="myModel = false"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import GateTabs from '../GateTabs.vue';
import PortalTableBody from '../PortalTableBody.vue';
import { routeNames } from '../../js/routeNames';
import axios from 'axios';
import { getPermissions } from '../../js/utils/userContext';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';

export default {
  data: function () {
    return {
      loading: false,
      myModel: false,
      gateData: [],
      permissions: [],
      modalData: '',
      search: '',
      filter: 'all',
      model: false,
      selectedDate: '',
      fileFormat: 'pdf',
      test1: false,
      test2: false,
      test3: false,
      date: '',
      currentDate: '',
      dateFormat: 'YYYY-MM-DD',
      userName: '',
      
    };
  },
  props: {
    direction: String,
    sort: String,
  },
  components: {
    GateTabs,
    DatePicker,
    PortalTableBody,
  },
  computed: {
    routeNames: () => {
      return routeNames;
    },

    refinedGates() {
      if (!Array.isArray(this.gateData)) {
        return [];
      }
      let refined = this.filterGates(this.gateData);
      refined = this.searchGates(refined);
      if (this.sort) {
        refined = this.sortGates(refined);
      }
      return this.direction === 'ascending' ? refined : refined.slice().reverse();
    },

    resultsCopy() {
      const length = this.refinedGates.length;
      return `${length}`; 
    },

    canCreateGate() {
      return this.permissions.includes('Create-Gate');
    },
    canEditGate() {
      return this.permissions.includes('Edit-Gate');
    },
    canDeleteGate() {
      return this.permissions.includes('Delete-Gate');
    },
  },
  mounted() {
    let today = new Date();
    this.currentDate = moment(today).format(this.dateFormat);
    this.userName = localStorage.getItem('username').replace(/['"]+/g, '');

    this.permissions = getPermissions();
    this.loadGates();
  },
  methods: {
    normalizeGateList(data) {
      if (Array.isArray(data)) {
        return data;
      }
      if (data && Array.isArray(data.data)) {
        return data.data;
      }
      if (data && Array.isArray(data.gates)) {
        return data.gates;
      }
      return [];
    },
    refreshPortalPage() {
      this.loadGates();
    },
    loadGates() {
      this.loading = true;
      axios
        .get(this.$hostName + '/gates')
        .then((response) => {
          this.gateData = this.normalizeGateList(response.data);
        })
        .catch((error) => {
          console.log(error);
          this.gateData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    filterGates(data) {
      const rows = Array.isArray(data) ? data : [];
      if (this.filter != 'all') {
        return rows.filter((gate) => {
          return gate.is_active.toString().toLowerCase() == this.filter;
        });
      }
      return rows;
    },
    sortGates(data) {
      const rows = Array.isArray(data) ? data.slice() : [];
      const sortKey = this.sort === 'name' ? 'display_name' : this.sort === 'status' ? 'is_active' : this.sort;
      if (!sortKey) {
        return rows;
      }
      return rows.sort((gateA, gateB) => {
        const valueA = gateA[sortKey];
        const valueB = gateB[sortKey];
        if (valueA < valueB) {
          return -1;
        }
        if (valueA > valueB) {
          return 1;
        }
        return 0;
      });
    },
    searchGates(data) {
      const rows = Array.isArray(data) ? data : [];
      if (!this.search) return rows;
      return rows.filter((gate) => {
        return (
          gate.display_name &&
          gate.display_name
            .toString()
            .toLowerCase()
            .includes(this.search.toString().toLowerCase())
        );
      });
    },
    downloadReports() {
      const fromDate = moment(this.selectedDate[0]).format('YYYY-MM-DD');
      const toDate = moment(this.selectedDate[1]).format('YYYY-MM-DD');
      const fileType = this.fileFormat;
      var formData = {
        fDate: fromDate,
        tDate: toDate,
        filter: this.filter,
        uName: this.userName,
        rName: 'Gate List',
        rType: 'gate',
        fType: fileType,
      };
      this.loading = true;
      axios({
        url: this.$hostName + '/downloadReport',
        method: 'POST',
        responseType: 'blob',
        data: formData,
      })
        .then((response) => {
          const binaryResponse = new Blob([response.data]);
          if (binaryResponse.size > 10) {
            var fileURL = window.URL.createObjectURL(binaryResponse);
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            var fileName =
              'Gates_' +
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
              '.' +
              fileType;
            fileLink.setAttribute('download', fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
          } else {
            this.$alert('No data for the selected filter criteria');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updatefilter(value) {
      this.filter = value;
    },
    updateSort(value) {
      this.$emit('updateSort', value);
    },
    createNewGate() {
      this.$router.push({ name: routeNames.newGate });
    },
    goToRoute(route) {
      if (this.navOpen) this.toggleNav();
      if (route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    },
    editGateDetails(idx){
      var editid = this.refinedGates[idx].id;
      var display_name = this.refinedGates[idx].display_name;
      var is_active = this.refinedGates[idx].is_active;
      this.$router.push({
        name: 'edit-gate',
        params: {
          display_name,
          is_active,
          editid,
        },
      });

    },
    openModel(idx) {
      this.myModel = true;
      this.modalData = idx;
    },
    reportsModel() {
      this.model = true;
    },
    deleteGate(idx) {
      this.loading = true;
      axios
        .delete(this.$hostName + '/gate/' + this.refinedGates[idx].id)
        .then((response) => {
          if (response.status == 200) {
            this.myModel = false;
            this.$emit('Gate Deleted');
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.reloadGatesAfterDelete();
        });
    },
    reloadGatesAfterDelete() {
      axios
        .get(this.$hostName + '/gates')
        .then((response) => {
          this.gateData = this.normalizeGateList(response.data);
        })
        .finally(() => {
          this.loading = false;
          this.$alert('Gate removed succesfully');
        });
    },
  },
};
</script>

<style scoped lang="scss">
.no-data-cell {
  padding: 24px 8px;
  color: $general-black-light;
  font-style: italic;
}
.radio-btn {
  margin-left: 5%;
}
.gate-reports {
  background-color: #f0f7ff;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-left: 1%;
  margin-right: 1%;
}
.report-title {
  margin-left: 2%;
}
.report-btn {
  margin-right: 2%;
}
.gate-table {
  min-height: 180px;
  flex: 1 1 auto;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-content {
  width: 500px !important;
}
.icon {
  font-size: 25px;
}
.edit {
  color: #007bff;
  top: 5px;
  margin-right: 10px;
}
.edit:hover {
  cursor: pointer;
}
.delete {
  color: red;
  margin-left: 10px;
}
.delete:hover {
  cursor: pointer;
}
.add:hover {
  cursor: pointer;
}
.title {
  display: flex;
  justify-content: center;
}
.gate-header {
  margin-top: 2%;
  margin-bottom: 2%;
  margin-left: 5%;
  margin-right: 5%;
}
.gate-manager {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
